import { useSelector } from 'react-redux';
import { FormPreRegistration } from './FormPreRegistration';
import { PreRegistrationUnified } from './PreRegistrationUnified';
import image from '../../static/image/4.png';

export const PreRegistrationPage = () => {
	const { email, emailExist } = useSelector((state) => state.preRegistration);
	/* No usar `loading` aquí: el mismo flag sirve para registro/pago y haría parpadear el wizard. */
	const showWizard = Boolean(email && emailExist);

	return (
		<div className='w-full flex'>
			{showWizard ? (
				<div className='w-full h-screen flex flex-col min-h-0'>
					<PreRegistrationUnified />
				</div>
			) : (
				<>
					<div className='w-full h-screen lg:w-[40%] flex flex-col min-h-0'>
						<FormPreRegistration />
					</div>
					<div
						className='w-0 lg:w-[60%] h-screen bg-cover'
						style={{ backgroundImage: `url(${image})` }}
					/>
				</>
			)}
		</div>
	);
};
